<template>
  <generic-view :prepend="url" :steps="steps" not-numbered :loading="loading">
    <introduction v-show="step == 'introduction'" endpoint="inspection-professionnelle" @next-step="next"></introduction>
    <template v-if="sas">
      <div v-for="s in realSteps" :key="s.path">
        <div v-show="step == s.path">
          <headline :code="s.code"></headline>
          <component :is="s.path" :sas="sas" @validation-changed="setState(s.path, $event)" :ref="s.path">
            <ressource :code="s.code" />
          </component>
          <v-btn color="#3a3838" dark class="mt-6" x-large @click="next">Enregistrer et continuer</v-btn>
        </div>
      </div>
      <soumission v-show="step == 'soumission'" :showAlert="formulaireNonValide" @submit="submit" ref="soumission"></soumission>
    </template>
  </generic-view>
</template>

<script>
import Introduction from "@/components/FormParts/Introduction"
import InspectionEtape1 from "@/components/InspectionProfessionnelle/InspectionEtape1.vue"
import InspectionEtape2 from "@/components/InspectionProfessionnelle/InspectionEtape2.vue"
import InspectionEtape3 from "@/components/InspectionProfessionnelle/InspectionEtape3.vue"
import Engagements from "@/components/InspectionProfessionnelle/Engagements.vue"
import Soumission from "@/components/FormParts/Soumission"
import FormulaireViewBase from "@/mixins/FormulaireViewBase"
import FormulaireBase from "@/mixins/FormulaireBase"

export default {
  mixins: [FormulaireViewBase, FormulaireBase],

  data() {
    return {
      url: "/inspection-professionnelle/",
      paramsName: "inspection-professionnelle",
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "inspectionEtape1", code: "titre-etape-1", state: "" },
        { path: "inspectionEtape2", code: "titre-etape-2", state: "" },
        { path: "inspectionEtape3", code: "titre-etape-3", state: "" },        
        { path: "engagements", code: "titre-etape-4", state: "" },        
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    Introduction,
    InspectionEtape1,
    InspectionEtape2,
    InspectionEtape3,
    Engagements,
    Soumission
  },

  metaInfo() {
    return {
      title: this.$i18n.t("meta.formulaires.title")
    }
  }
}
</script>

<style>
</style>